"use client";

import SearchBar from "@/components/SearchBar";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import React from "react";

function CampaignsSearch({ onSearch }) {
  const t = useTranslationDetector("campaigns");

  const handleSearchCampaigns = (searchTerm) => {
    onSearch?.(searchTerm);
  };

  return (
    <SearchBar
      placeholder={t("searchPlaceholder")}
      onSearch={handleSearchCampaigns}
      containerClass="w-full md:max-w-[272px]"
      showClearOnType={true}
      hideIconWhenClear={false}
    />
  );
}

export default CampaignsSearch;